const OPERATION_TYPES = Object.freeze({
  NEW_APPLICANT: "New Applicant",
  NEW_BUSINESS: "New Business"
});

export default OPERATION_TYPES